import { render } from "./ConfirmSanitization.vue?vue&type=template&id=157e718e"
import script from "./ConfirmSanitization.vue?vue&type=script&lang=js"
export * from "./ConfirmSanitization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__